<template>
  <div class="attention">
    <div>注意事項</div>
  </div>
</template>

<script>
export default {
  name: 'Attention'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Attention.vue